"use client";

import dynamic from "next/dynamic";
import type { Root, RootContent, Element } from "hast";

const MarkdownPreview = dynamic(() => import("@uiw/react-markdown-preview"), {
  ssr: false,
  loading: () => <div className="skeleton h-48 w-full" />,
});

// Inline rehype plugin: strips javascript: URLs from href/src/action attributes.
// Avoids adding rehype-sanitize as a dependency by walking the hast tree directly.
function rehypeStripJavascriptUrls() {
  function walk(nodes: RootContent[]) {
    for (const node of nodes) {
      if (node.type === "element") {
        const el = node as Element;
        const props = el.properties ?? {};
        for (const attr of ["href", "src", "action"]) {
          const val = props[attr];
          if (typeof val === "string" && /^\s*javascript:/i.test(val)) {
            props[attr] = "#";
          }
        }
        if (el.children) walk(el.children as RootContent[]);
      }
    }
  }
  return function (tree: Root) {
    walk(tree.children as RootContent[]);
  };
}

export function MarkdownClient({ source }: { source: string }) {
  return (
    <MarkdownPreview
      source={source}
      rehypePlugins={[rehypeStripJavascriptUrls]}
    />
  );
}
